import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import ProjectDeptStatContainer from '../../containers/project_dept_stat/ProjectDeptStatContainer';

const ProjectDeptStatViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="통계/수주관리/프로젝트 통계"
        icon="statistics"
      />
      <ProjectDeptStatContainer />
    </div>
  );
};

export default ProjectDeptStatViewPage;
